<style>
#pdpaModal {
    text-align: left;
}
</style>
<template>
    <div class="modal fade" id="pdpaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header"><button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button></div>
                <div class="modal-body" @scroll="onScroll">
                    <h5 class="fw-bold">RENEW+ SUBSCRIPTION PROGRAM TERMS AND CONDITIONS</h5>
                    <div class="mt-5">
                        <p> This <span class="fw-bold">ReNew+ Subscription Program </span>("<span class="fw-bold">Program </span>")
                            is provided to you by <span class="fw-bold">CompAsia Sdn. Bhd. </span>(Company No. (201201022161) (“<span class="fw-bold">CompAsia</span>”) and is subject to this terms and condition (“<span class="fw-bold">T&amp;C</span>”). You acknowledge that you have read and understood this T&amp;C. Your purchase and use of the Program, upon subscription, constitutes acceptance of this T&amp;C and you agree to be bound by this T&amp;C which may be amended from time to time.</p>
                        <p>A reference to “you” and “your” means the customer who seeks to subscribe or has subscribed for the Program.</p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>1.</td>
                                <td>PROGRAM AND SERVICE DESCRIPTION</td>
                            </tr>
                            <tr>
                                <td>1.1</td>
                                <td>The Program enables you to subscribe for any device under the Program on a subscription basis where you enjoy device upgrade or optionally, take ownership of the device upon the completion of your Subscription Period (“<span class="fw-bold">Service</span>”), subject to the terms of this T&amp;C and the Device Subscription Agreement (“<span class="fw-bold">DSA</span>”).</td>
                            </tr>
                            <tr>
                                <td>1.2</td>
                                <td>To enjoy the Service, you must apply to subscribe to the Program for any of the eligible Device from the respective participating Partner's website and be successfully approved for the Program and complete the Monthly Charge.</td>
                            </tr>
                            <tr>
                                <td>1.3</td>
                                <td>Upon subscription and completion of the payment of applicable Monthly Charge and/or fees, you may upgrade your Registered Device for another brand-new original Device in accordance to Item 6 of this T&amp;C.</td>
                            </tr>
                            <tr>
                                <td>1.4</td>
                                <td>We reserves the right to suspend, modify or discontinue any part or all of the Program at any time at our sole discretion.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>2.</td>
                                <td>DEFINITION</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="py-2">For the purpose of this T&amp;C, the following terms shall, unless the context otherwise requires, have the meanings as defined below. All other terms not defined herein shall have the meaning as may generally be accepted within the industry based on the context used herein:</td>
                            </tr>
                            <tr>
                                <td>2.1</td>
                                <td> <span class="fw-bold">Assigned Account </span>means a banking account which details are as provided by the Customer upon application process to subscribe for the Program.</td>
                            </tr>
                            <tr>
                                <td>2.2</td>
                                <td> <span class="fw-bold">Business Days </span>means Monday to Friday except for Saturday, Sunday and the gazetted Public Holidays in Malaysia.</td>
                            </tr>
                            <tr>
                                <td>2.3</td>
                                <td> <span class="fw-bold">Device </span>means any portable electronic equipment that has a display screen, supports one or more wireless network connectivity options, operates using voice, touch or a miniature keyboard including mobile cellular devices with a valid IMEI, laptops and tablets with unique serial number. It does not include any Device Accessories.</td>
                            </tr>
                            <tr>
                                <td>2.4</td>
                                <td> <span class="fw-bold">Device Accessory </span>means anything that is either provided by the OEM with a Device or sold separately to be used in conjunction with a Device. It includes batteries, SIM cards, memory cards, chargers, ear buds, boxes, cases, cables, styli, mounts and docking stations.</td>
                            </tr>
                            <tr>
                                <td>2.5</td>
                                <td> <span class="fw-bold">Hardware Modification </span>means any modification made to a Device's hardware not undertaken or authorised by the OEM.</td>
                            </tr>
                            <tr>
                                <td>2.6</td>
                                <td> <span class="fw-bold">IMEI </span>means the international mobile equipment identity number of a Device.</td>
                            </tr>
                            <tr>
                                <td>2.7</td>
                                <td> <span class="fw-bold">Modification </span>means Software Modification or Hardware Modification or both.</td>
                            </tr>
                            <tr>
                                <td>2.8</td>
                                <td> <span class="fw-bold">NRIC </span>means a valid National Registration Identity Card issued by the Government of Malaysia.</td>
                            </tr>
                            <tr>
                                <td>2.9</td>
                                <td> <span class="fw-bold">OEM </span>means original manufacturer of a Device.</td>
                            </tr>
                            <tr>
                                <td>2.10</td>
                                <td> <span class="fw-bold">Partner </span>means a supplier of Device to CompAsia and shall make available the Devices to the Customer under the Program.</td>
                            </tr>
                            <tr>
                                <td>2.11</td>
                                <td> <span class="fw-bold">Program Fee </span>means a fee imposed on the Customer for every successful subscription to the Program which the amount is as stipulated under Item 6.1.1 of this T&C.</td>
                            </tr>
                            <tr>
                                <td>2.12</td>
                                <td> <span class="fw-bold">Nominal Value </span>means the amount payable by the Customer to CompAsia amounting to a fixed Ringgit Malaysia One (RM1.00) which is the pre-authorization fee paid by the Customer.</td>
                            </tr>
                            <tr>
                                <td>2.13</td>
                                <td> <span class="fw-bold">Registered Device </span>means a Device purchased by a Customer from the Partner where the IMEI/unique serial number of the Device has been registered under the Program.</td>
                            </tr>
                            <tr>
                                <td>2.14</td>
                                <td> <span class="fw-bold">Self-Collection Date </span>means the date you collect the Registered Device at the Partner's stores.</td>
                            </tr>
                            <tr>
                                <td>2.15</td>
                                <td> <span class="fw-bold">Self-Collection </span>means self-collection of the Device by the Customers:<table>
                                        <tr>
                                            <td>(a) </td>
                                            <td>at any participating Partner's store nationwide; and</td>
                                        </tr>
                                        <tr>
                                            <td>(b) </td>
                                            <td>on any days including national and state public holidays from 10am to 10pm.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>2.16</td>
                                <td> <span class="fw-bold">Software Modification </span>means modification made to a Registered Device's operating system not undertaken or authorized by the OEM which includes “jail-breaking” and “rooting”.</td>
                            </tr>
                            <tr>
                                <td>2.17</td>
                                <td> <span class="fw-bold">Upgrade Request </span>means a request by a Customer who subscribed to the Program to upgrade his/her Registered Device to a brand new Device as per the terms stipulated under this T&amp;C and the DSA.</td>
                            </tr>
                            <tr>
                                <td>2.18</td>
                                <td> <span class="fw-bold">Upgraded Device </span>means a Device which a Customer receives after tendering her/his Registered Device upon a successful Upgrade Request.</td>
                            </tr>
                            <tr>
                                <td>2.19</td>
                                <td> <span class="fw-bold">Website </span>means the Partner website.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>3.</td>
                                <td>SUBSCRIPTION TO THE PROGRAM</td>
                            </tr>
                            <tr>
                                <td>3.1</td>
                                <td>Eligibility - You are eligible to subscribe to the Program if you are a Malaysian citizen aged between twenty-one (21) to sixty-five (65) years old with a valid NRIC and earning a minimum monthly wages of RM1,000.00 (“<span class="fw-bold">Customer</span>”).</td>
                            </tr>
                            <tr>
                                <td>3.2 </td>
                                <td>When to Subscribe - You must make your application to subscribe to the Program at the time you purchase your Registered Device by providing a copy of your NRIC and any other necessary documents which may be requested during your application.</td>
                            </tr>
                            <tr>
                                <td>3.3 </td>
                                <td>Approval - Upon receiving your application, we will review and conduct the necessary verification to determine your eligibility for the Program. You will be notified on the status of your application through email or any other form of communication no later than four (4) Business Days.</td>
                            </tr>
                            <tr>
                                <td>3.4</td>
                                <td> Status of Application<table>
                                        <tr>
                                            <td>(i) </td>
                                            <td> <u>Successful Application</u><br />If your application is successful, the participating Partner will contact to assist you with the Self Collections of your Registered Device. Kindly refer to Item 4 for further details on Self Collection.</td>
                                        </tr>
                                        <tr>
                                            <td>(ii) </td>
                                            <td><u>Unsuccessful Application</u><br />If your application is unsuccessful, you will be notified via email or any other forms of communication whereby all the charges imposed on you during your application to subscribe to the Program will be refunded to you as per specified in the email.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>3.5 </td>
                                <td>Confirmation of Subscription - Upon collection of your Registered Device, you will be required to sign a DSA which shall confirm and conclude your application to the Program.</td>
                            </tr>
                            <tr>
                                <td>3.6 </td>
                                <td>Your subscription to the Program shall be effective on the commencement date of your DSA (“<span class="fw-bold">Commencement Date</span>”).</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>4.</td>
                                <td>DEVICE COLLECTION</td>
                            </tr>
                            <tr>
                                <td>4.1 </td>
                                <td>Upon successfully subscribed to the Program, you will be contacted by our Partner via email/other form of communciation with details on the Self Collection.</td>
                            </tr>
                            <tr>
                                <td>4.2 </td>
                                <td>Your Registered Device shall be collected on the Self-Collection Date. Failure to collect your Registered Device on the Self-Collection Date shall not absolve you from any or/and all obligations imposed on you under this T&amp;C and the DSA.</td>
                            </tr>
                            <tr>
                                <td>4.3 </td>
                                <td>You are not allowed to nominate any other person to collect your Registered Device on your behalf. Only the Customer being the person whose name is stated and registered in the application form is allowed to collect the Registered Device.</td>
                            </tr>
                            <tr>
                                <td>4.4 </td>
                                <td>When collecting your Registered Device, our Partner/Partner's staff will assist you with the mandatory verification process (“EKYC”) before handing you the Registered Device.</td>
                            </tr>
                            <tr>
                                <td>4.5 </td>
                                <td>If you do not pass the EKYC, you will not be allowed to collect the Registered Device. Subsequently, your application is revoked and any payment made by you will be refunded.</td>
                            </tr>
                            <tr>
                                <td>4.6 </td>
                                <td>We shall not be liable for any issues arising out of the arrangement for collection, delays and availability of stocks during the collection of your Registered Device.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>5.</td>
                                <td>TERM OF SUBSCRIPTION</td>
                            </tr>
                            <tr>
                                <td>5.1 </td>
                                <td>Your subscription to the Program is for a term of twelve (12) or twenty-four (24) months (“<span class="fw-bold">Subscription Period</span>”) from the Commencement Date.</td>
                            </tr>
                            <tr>
                                <td>5.2 </td>
                                <td>During the Subscription Period, you are not allowed to either increase or reduce your Subscription Period.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>6.</td>
                                <td>FEES AND CHARGES</td>
                            </tr>
                            <tr>
                                <td>6.1 </td>
                                <td>Initial Payment<table>
                                        <tr>
                                            <td>6.1.1</td>
                                            <td>Upon registration of the Program, you will be automatically charged with the Nominal Value, the first Monthly Charge and the Program Fee. The value for the Program Fee shall be subjected to the respective Subscription Period, as follows:

                                                <ul>
                                                    <li>Ringgit Malaysia One Hundred (RM100.00) for 12 months Subscription Periood; or</li>
                                                    <li>the amount equivalent to one month of the Monthly Charge for 24 months Subscription Period.</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>6.1.2</td>
                                            <td>Upon the successful final credit verification of your application, you will be notified by e-mail/other form of communication.</td>
                                        </tr>
                                        <tr>
                                            <td>6.1.3</td>
                                            <td>In the event of an unsuccessful final credit verification of your application, you will be notified by e-mail of your unsuccessful application and your Nominal Value, first Monthly Charge and Program Fee shall be refunded to you.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>6.2 </td>
                                <td>Monthly Charge<table>
                                        <tr>
                                            <td>6.2.1</td>
                                            <td>The Monthly Charge is the monthly amount which you are required to pay to us for your subscription to the Program throughout the Subscription Period.</td>
                                        </tr>
                                        <tr>
                                            <td>6.2.2</td>
                                            <td>The amount of your Monthly Charge differs according to the Registered Device and shall be as specified in the DSA.</td>
                                        </tr>
                                        <tr>
                                            <td>6.2.3</td>
                                            <td>Your Monthly Payment will be automatically deducted from your Assigned Account via auto debit payment method.</td>
                                        </tr>
                                        <tr>
                                            <td>6.2.4</td>
                                            <td>You are responsible for providing accurate and complete information of your Assigned Account to enable the performance of auto debit from our end. If you wish to change any information on your Assigned Account, you are required to contact our customer service in at least seven (7) Business Days before the due date of each Monthly Charge.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>6.3 </td>
                                <td>Late Payment Charges<table>
                                        <tr>
                                            <td>6.3.1</td>
                                            <td>To avoid interruption of Service and any Late Payment Charges, you shall ensure that your Assigned Account for the payment of the Monthly Charge is active and have sufficient funds.</td>
                                        </tr>
                                        <tr>
                                            <td>6.3.2</td>
                                            <td>In the event that your Monthly Charge fails to be automatically deducted from your Assigned Account when it falls due for any reason resulting from you, we reserve the right to impose a late payment charge of Ringgit Malaysia Ten (RM10.00) only for every seven (7) days commencing on the day after your payment falls due (“<span class="'fw-bold'">Late Payment Charge</span>”) until the overdue amount which shall comprise of the Monthly Charge and the Late Payment Charge are fully settled.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>6.4 </td>
                                <td>Early Termination Fee<table>
                                        <tr>
                                            <td>6.4.1 </td>
                                            <td>You may terminate your subscription to the Program before the expiry of the Subscription Period by contacting our customer service at least seven (7) Business Days before the due date of your Monthly Charge.</td>
                                        </tr>
                                        <tr>
                                            <td>6.4.2 </td>
                                            <td> You are required to pay an early termination fee (“<span class="fw-bold">Termination Amount</span>”) which the formula to calculate is as follows:<table>
                                                    <tr>
                                                        <td>Termination&nbsp;Amount </td>
                                                        <td>=</td>
                                                        <td>(Monthly Charge x Remaining Months balance) + Nominal Value + Late Payment Charge (if any).</td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>6.5 </td>
                                <td>Your subscription of the Registered Device will automatically be terminated if you default in payment of the Monthly Charge for three (3) consecutive months. You hereby agree that due to your default of the Monthly Charge and any Late Payment Charges, we reserve the right to exercise any means that we deem necessary to recover the Registered Device and the amount due and owing to us which shall include but not limited to, the blacklisting of your name (internal and external, whichever applicable) and blocking/blacklisting of the Registered Device (where applicable). You agree to bear any cost incurred by us in exercising this right.</td>
                            </tr>
                            <tr>
                                <td>6.6</td>
                                <td>Should there be any taxes, levies or duties that become applicable as required by law, we shall be obliged to impose such taxes, levies or duties to whatever charges as required.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>7. </td>
                                <td>UPGRADE OPTION</td>
                            </tr>
                            <tr>
                                <td>7.1 </td>
                                <td>The Registered Device is provided to you under this Program and you are accountable for the use and safety of the Registered Device.</td>
                            </tr>
                            <tr>
                                <td>7.2 </td>
                                <td>Upon your completion of your Subscription Period where you have paid the Monthly Charge and the Late Payment Charge (if any) in full, you will have the option to own or upgrade your Registered Device subject to the terms under this T&amp;C and the DSA.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>8. </td>
                                <td>UPGRADE REQUEST</td>
                            </tr>
                            <tr>
                                <td>8.1</td>
                                <td>Upon full payment of your Monthly Charge, if you choose not to own your Registered Device, you are able to upgrade your Registered Device to a brand-new Device by making an Upgrade Request to us.</td>
                            </tr>
                            <tr>
                                <td>8.2</td>
                                <td>In making an Upgrade Request, you are required to tender your Registered Device and shall be subjected to the terms stipulated herein.</td>
                            </tr>
                            <tr>
                                <td>8.3 </td>
                                <td>The Upgrade Request will only be accepted if:<table>
                                        <tr>
                                            <td>(a)</td>
                                            <td>the IMEI/unique serial number of the Device you return to us, subscriber's name, mobile phone number and the NRIC number under which the Device is subscribed to is correct and correspond with the information of the Registered Device and other information you have given to us during your application to subscribe to the Program;</td>
                                        </tr>
                                        <tr>
                                            <td>(b)</td>
                                            <td>you provide any additional information as reasonably requested by us;</td>
                                        </tr>
                                        <tr>
                                            <td>(c)</td>
                                            <td>it is made within thirty (30)days after the completion of Subscription Period;</td>
                                        </tr>
                                        <tr>
                                            <td>(d)</td>
                                            <td>the Upgrade Request is not for any Device Accessory;</td>
                                        </tr>
                                        <tr>
                                            <td>(e)</td>
                                            <td>the Registered Device is able to “power-on” and has not been the subject of Modification; and</td>
                                        </tr>
                                        <tr>
                                            <td>(f)</td>
                                            <td>we reasonably believe that you are not using the Program in a manner which is, or is reasonably believed to be, fraudulent, illegal or related to any criminal activity; or intended to make commercial gain.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>8.4</td>
                                <td>The Device you select for an upgrade is subject to the eligibility and availability of the Device under the Program.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>9. </td>
                                <td>UPGRADE OF DEVICE</td>
                            </tr>
                            <tr>
                                <td>9.1</td>
                                <td>Preparation - You must remove or disable any password or personal lock security feature before returning your Registered Device.</td>
                            </tr>
                            <tr>
                                <td>9.2</td>
                                <td>Device data - You shall be solely responsible for all data stored in your Registered Device and you shall delete all data from your Registered Device before it is tendered to us upon performing the upgrade of your Registered Device. We are not responsible for any data you left on the Registered Device and will not transfer any such data or information from your Registered Device. We shall not be liable for any loss, misappropriation of or damage to any data or information.</td>
                            </tr>
                            <tr>
                                <td>9.3</td>
                                <td> Self-Collect formalities - In order to complete the Upgrade Request, the participating Partner's store staff carrying out the upgrade:<table>
                                        <tr>
                                            <td>(a)</td>
                                            <td>will ask for and verify that the NRIC number you provide during the self- collection of the Upgraded Device corresponds to the NRIC number you provide when making the Upgrade Request;</td>
                                        </tr>
                                        <tr>
                                            <td>(b)</td>
                                            <td>will verify that the Device you tender is the Registered Device provided to you upon your subscription to the Program (by comparing the make, model and IMEI/unique serial number of the Registered Device with the Device you present),</td>
                                        </tr>
                                        <tr>
                                            <td>(c)</td>
                                            <td>will inspect the returned Registered Device to check if it is able to be turned on and that it does not undergo any Modification; and</td>
                                        </tr>
                                        <tr>
                                            <td>(d)</td>
                                            <td>will pass to you the brand-new Upgraded Device upon satisfaction of the above.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>9.4</td>
                                <td>Failure to disable locking - If the Partner's staff/we discover that, the password or personal lock security feature of your Registered Device is not removed or disabled upon you tendering the Registered Device for the upgrade, your Upgrade Request may be rejected.</td>
                            </tr>
                            <tr>
                                <td>9.5</td>
                                <td>Modified Devices - If the Partner's staff/we discovers that the Registered Device you tender has undergone Modification, we will at our sole discretion reject the Upgrade Request.</td>
                            </tr>
                            <tr>
                                <td>9.6</td>
                                <td>GRV - We guarantee that your Registered Device returned for the upgrade will be bound to a Guaranteed Resale Value (“GRV”) up to fifty percent (50%) (or any other amount which shall be communicated to you) of the original retail price of the Registered Device at the Commencement Date.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>10. </td>
                                <td>TERM AND TERMINATION</td>
                            </tr>
                            <tr>
                                <td>10.1</td>
                                <td>Term of Program - The Program will be made available to you starting from the Effective Date of the DSA until the expiration of your respective Subscription Period, unless earlier terminated.</td>
                            </tr>
                            <tr>
                                <td>10.2</td>
                                <td>Early Termination - You may terminate your subscription before the expiry of your Subscription Period which you are required to pay a Termination Fee as referred in Item 6.4 of this T&amp;C.</td>
                            </tr>
                            <tr>
                                <td>10.3</td>
                                <td> Termination by CompAsia - We may immediately terminate the Program and/or the DSA with you at any time if we reasonably believe that:<table>
                                        <tr>
                                            <td>(a) </td>
                                            <td>you defaulted in payment of the Monthly Charge or the Late Payment Fee (if any) for three (3) consecutive months;</td>
                                        </tr>
                                        <tr>
                                            <td>(b) </td>
                                            <td>you are using the Service (whether directly or indirectly, intentionally or not) in a way that may adversely impact our reputation;</td>
                                        </tr>
                                        <tr>
                                            <td>(c) </td>
                                            <td>you are using the Service in a manner which is, or is reasonably believed to be, fraudulent, illegal or related to any criminal activity; or intended to make commercial gains;</td>
                                        </tr>
                                        <tr>
                                            <td>(d) </td>
                                            <td>you have breached, or are likely to breach this T&amp;C or have engaged in cheating;</td>
                                        </tr>
                                        <tr>
                                            <td>(e) </td>
                                            <td>you are or may become bankrupt or unable to pay your debts as they fall due;</td>
                                        </tr>
                                        <tr>
                                            <td>(f) </td>
                                            <td>you have provided us with incorrect, false or incomplete information;</td>
                                        </tr>
                                        <tr>
                                            <td>(g) </td>
                                            <td>you are likely to create imminent harm or harass or are abusive to any of our personnel including our service providers, sub-contractors and agents; or</td>
                                        </tr>
                                        <tr>
                                            <td>(h) </td>
                                            <td>for any other reason at our sole discretion;</td>
                                        </tr>
                                        <tr>
                                            <td>(i) </td>
                                            <td>you have transferred, sold, displayed for sale, or let on hire your Registered Device.</td>
                                        </tr>
                                        <tr>
                                            <td>(j) </td>
                                            <td>you do or conduct any act or thing which may prejudice or jeopardise the our rights in respect of the Registered Device.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>10.4</td>
                                <td> Consequences of termination<table>
                                        <tr>
                                            <td>(a) </td>
                                            <td>No refund - To the extent that we are not in breach of any of our obligations under this T&amp;C and the DSA, if your Subscription is terminated under clause 10.3, you will not be refunded any part of the fees and charges that you have paid.</td>
                                        </tr>
                                        <tr>
                                            <td>(b) </td>
                                            <td>No reactivation - Once your Registered Device is terminated from the Program, the Program cannot be reactivated for that Registered Device.</td>
                                        </tr>
                                        <tr>
                                            <td>(c) </td>
                                            <td>Prohibition - With respect to a customer with a valid NRIC, if you have been previously rejected or terminated from the Program.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>11. </td>
                                <td>REFUND OF PAYMENT</td>
                            </tr>
                            <tr>
                                <td>11.1 </td>
                                <td>Any refund would be made to you based on the e-mail/any other communication which will be sent to you specifying the details of the refund.</td>
                            </tr>
                            <tr>
                                <td>11.2 </td>
                                <td>The amount of refund would be disbursed to the Assigned Account which you have provided to us during your application to subscribe to the Program.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>12. </td>
                                <td>GENERAL TERMS OF USE</td>
                            </tr>
                            <tr>
                                <td>12.1 </td>
                                <td>The Registered Device will only be used by the Customer in a proper manner, and in accordance with the operating instructions/manual for the Registered Device.</td>
                            </tr>
                            <tr>
                                <td>12.2 </td>
                                <td>The Customer shall keep the Registered Device in the possession and control of the Customer at all times.</td>
                            </tr>
                            <tr>
                                <td>12.3 </td>
                                <td>The Customer will take due and proper care of the Registered Device, and the Customer shall ensure that the Registered Device is not defaced and/or modified in any way.</td>
                            </tr>
                            <tr>
                                <td>12.4 </td>
                                <td>If applicable, the Customer shall conduct and carry out daily and/or routine maintenance and service of the Registered Device in accordance with the recommendations, conditions and specifications made or prescribed by the manufacturer of the Registered Device.</td>
                            </tr>
                            <tr>
                                <td>12.5 </td>
                                <td>Any regulatory or certification markers affixed to the Registered Device will not be removed, defaced or obstructed.</td>
                            </tr>
                            <tr>
                                <td>12.6 </td>
                                <td>The Customer shall assume all responsibility, liability, risks and rewards for the Registered Device at the Commencement Date.</td>
                            </tr>
                            <tr>
                                <td>12.7 </td>
                                <td>The Customer hereby agrees and acknowledges that we shall not be responsible for any issue or matter relating to any mobile line/services which are used by Customer for the Registered Device. The Customer shall be solely responsible to pay all charges and costs in connection with the mobile line/services, directly to the relevant telecommunications provider.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>13. </td>
                                <td>DATA PRIVACY</td>
                            </tr>
                            <tr>
                                <td>13.1</td>
                                <td>You confirm that you have read, understood and consent to us the personal data protection policy and privacy notice which may be found at http://CompAsia.com.my/privacy or such other link as may be notified by us (together, the PDP Policy).</td>
                            </tr>
                            <tr>
                                <td>13.2</td>
                                <td> You also agree that by applying for or using the Program:<table>
                                        <tr>
                                            <td>(a) </td>
                                            <td> you are giving us the consent to (and data intermediary, for the purpose of the Personal Data Protection Act 2010) to use and/or disclose your personal information collected from you:<table>
                                                    <tr>
                                                        <td>(i) </td>
                                                        <td>in accordance with the PDP Policy;</td>
                                                    </tr>
                                                    <tr>
                                                        <td>(ii) </td>
                                                        <td> for the purpose of:<table>
                                                                <tr>
                                                                    <td>1. </td>
                                                                    <td>assessing your eligibility to subscribe, and continue to be subscribed for the Program;</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>2. </td>
                                                                    <td>providing you with the Program;</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>3. </td>
                                                                    <td>generating aggregated and non-personally identifiable data sets;</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>4. </td>
                                                                    <td>allowing direct and indirect contact with you in connection with the Program; and</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>5. </td>
                                                                    <td>managing commercial risks, and preventing, detecting, and investigating suspected illegal activity, fraud, or disputes</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2">(the purposes above shall collectively be referred to as the “<span class="fw-bold">Purposes</span>”)</td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>(iii) </td>
                                                        <td>to any relevant governmental and/or regulatory authorities where legally required; and</td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>(b) </td>
                                            <td>you consent to our service provider storing or hosting data with our affiliates, Partners, subsidiaries and unaffiliated third parties including third-party service providers, whether in Malaysia or other countries, for the Purposes or for any other purpose specified in the PDP Policy.</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>13.3 </td>
                                <td>We are the data user of your personal information at all times and any enquiries on the processing of your personal information will be made in accordance with the PDP Policy.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>14. </td>
                                <td>AMENDMENT/VARIATION</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Any amendment and/or variation of any terms and conditions of this T&amp;C will be at our sole discretion and will be announced and/or posted on our website which we may notify the Customer through e-mail communication. Such amendment and/or variation as announced and/or shall be deemed to become effective as per the date being stipulated in the announcement and/or communication.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>15. </td>
                                <td>COMPLIANCE WITH LAWS</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Both us and the Customer shall comply with all applicable laws, rules, regulations and guidelines governing the duties, obligations and business practices of both us and Customer. Further, the parties shall not do or omit to do anything that violates any applicable law, rule, regulation and guideline that could result in liability being imposed on the other party.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>16. </td>
                                <td>ANTI-CORRUPTION/BRIBERY</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="pb-2">Each party undertakes that neither party nor any party acting on the party's behalf has offered, promised, given, authorised, requested or accepted any undue financial or other advantage of any kind in any way connected with any purpose including the entering into this T&amp;C, nor has either party made any improper payments, given gifts or inducements of any kind to and received from any person, including officials in the public or private sector, customers and suppliers.</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="pb-2">Each party shall throughout the term of this T&amp;C comply with and take reasonable measures to ensure that any other parties acting on the party's behalf comply with all applicable laws, statutes and regulations relating to anti-bribery and anti-corruption (both domestic and foreign) which would be applicable to them, whichever is the more stringent.</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="pb-2">Each party shall maintain in place throughout the term of this T&amp;C, the party's own policies and procedures to ensure compliance with anti-bribery and anti-corruption laws, statutes and regulations including the maintaining of detailed and accurate accounting records for transactions, including cash and bank accounts and shall enforce them where appropriate.</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Each party shall immediately report to the relevant authority and to the other party any offer, request or demand for any undue financial or other advantage of any kind made by or received from the other party or any party acting on the party's behalf and/or from any officials in the public or private sector, customers and suppliers.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>17. </td>
                                <td>MISCELLANEOUS</td>
                            </tr>
                            <tr>
                                <td>17.1 </td>
                                <td>Governing laws - This T&amp;C will be governed by and construed in accordance with the laws of Malaysia.</td>
                            </tr>
                            <tr>
                                <td>17.2 </td>
                                <td>General indemnity - In no event will we or their service providers, be liable to you or anyone else for any direct, indirect, special, exemplary or consequential damages, or any damage arising out of or in connection with your access, use of, or your inability to access or use the Service or the performance or non-performance of the Service.</td>
                            </tr>
                            <tr>
                                <td>17.3 </td>
                                <td>Promotions - We may from time to time offer promotions relating to the Program. Any such promotion shall be governed by the terms and conditions attached thereto by the Program, and by this T&amp;C to the extent that the promotion's terms and conditions are silent. In the event of any conflicts between a promotion's terms and conditions and this T&amp;C, this T&amp;C prevail.</td>
                            </tr>
                        </table>
                        </p>
                        <p>
                        <table>
                            <tr class="fw-bold">
                                <td>18. </td>
                                <td>ENQUIRIES</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>If you have any queries, complaints, claims or feedback regarding the Program, you may visit any partner store or contact the ReNew+ CompAsia Customer Service at renew.plus@compasia.com</td>
                            </tr>
                        </table>
                        </p>
                    </div>
                </div>
                <div class="modal-footer pt-3">
                    <div class="d-flex justify-content-between w-100">
                        <div>By clicking accept, I acknowledge to PDPA and Terms &amp; Conditions </div>
                        <div class="d-flex"><button class="btn btn-primary pr-3" type="button" @click='$emit("cekFund")' :disabled="!accept" data-bs-dismiss="modal">Accept</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        accept:false,
      }
    },
    methods: {
      onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
        console.log(scrollTop + clientHeight,scrollHeight);
        if (scrollTop + clientHeight >= scrollHeight - clientHeight) {
          this.accept = true;
        }
      }
    }
  }
</script>

<style scoped>
  p + p {
    margin-top: 2.5rem;
  }
  tr {
    vertical-align: top;
  }
  td:first-child {
    width: 2rem;
  }
  td + td {
    padding-left: 1rem;
  }
</style>